import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NoAuthGuard implements CanActivate {
  constructor(
    private auth: AuthService,
    private router: Router,
  ) {}

  canActivate(): Observable<boolean> {
    return this.auth.isAuthenticated$.pipe(
      map((isAuthenticated) => !isAuthenticated), // ---> Allow access if NOT authenticated
      tap((isAllowed) => {
        if (!isAllowed) {
          this.router.navigate(['/dashboard']); // ---> Redirect to dashboard if authenticated
        }
      }),
    );
  }
}
